import React from "react";
import "./CustomButton.css";

type props = {
  onPress: () => void;
  title: string;
};

export const CustomButton: React.FC<props> = ({ onPress, title }) => {
  return (
    <div onClick={onPress} className="custom-btn-container">
      <span className="custom-btn-text">{title}</span>
    </div>
  );
};
